import jwt_decode from "jwt-decode";
import i18n from "@/i18n.js";

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (const element of ca) {
    var c = element;
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
const token = getCookie("LTI_JWT");

if (token) {
  try {
    let jwtDecoded = jwt_decode(token);
    i18n.locale = jwtDecoded.language;
    i18n.fallbackLocale = jwtDecoded.language;
  } catch (e) {
    i18n.locale = "es";
  }
} else {
  i18n.locale = "es";
}

export default {
  methods: {
    /**
     * Obtiene el id del usuario desde le token JWT
     * @returns user
     */
    getUser() {
      return jwt_decode(token).user;
    },
    /**
     * Método que formatea una duración en formato hh:mm:ss
     */
    msToTime(s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;

      return this.pad(hrs) + ":" + this.pad(mins) + ":" + this.pad(secs);
    },
    pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    },
    /**
     * Método que da formato a un número de PIN de conexión telefónica
     */
    formatPIN(phonePIN) {
      let t = " ";
      let n = 3;
      let s = phonePIN.toString().match(new RegExp(".{1," + n + "}", "g"));
      if (s) {
        let o = s[s.length - 1];
        if (s.length > 1 && o.length < n && (s[s.length - 2] += s.pop())) {
          return s.join(t);
        }
      }
    },
    /**
     * Función que determina si una sesíon está en curso
     */
    isOngoing(review) {
      let now = window.moment().utc();
      return (
        window.moment(review.startDate).isBefore(now) &&
        (!review.endDate || window.moment(review.endDate).isAfter(now))
      );
    },
    /**
     * Funcíon que determina si una sesíon aún no ha comenzado
     */
    notYetStarted(review) {
      let now = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      return window.moment(review.startDate).isAfter(now);
    },
    /**
     * Funcíon que determina si una sesíon ha finalizado
     */
    hasEnded(review) {
      return !this.isOngoing(review) && !this.notYetStarted(review);
    },
    /**
     * Método que determina si la inscripción de la review a finalizado
     * */
    isSubcribePeriod(review) {
      let now = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      return (
        window.moment(now).isSameOrAfter(review.signupStartDate) &&
        window.moment(now).isBefore(review.signupEndDate)
      );
    },
    /**
     * Método que determina si la inscripción de la review a finalizado
     * */
    subcribeFinish(review) {
      let now = new Date();
      return window.moment(now).isAfter(review.signupEndDate);
    },
    /*
     * Calcula la fecha según número, unidad y fecha de referencia.
     * resta fecha
     */
    calculateFromDate(date, number, unit) {
      let plusUnit;
      if (parseInt(unit) === 1) plusUnit = "minute";
      if (parseInt(unit) === 2) plusUnit = "hour";
      if (parseInt(unit) === 3) plusUnit = "day";
      return window
        .moment(date)
        .add(parseInt(number), plusUnit)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    },
    /*
     * Calcula la fecha según número, unidad y fecha de referencia.
     * suma fecha
     */
    calculateToDate(date, number, unit) {
      let lessUnit;
      if (parseInt(unit) === 0) return new Date();
      if (parseInt(unit) === 1) lessUnit = "minute";
      if (parseInt(unit) === 2) lessUnit = "hour";
      if (parseInt(unit) === 3) lessUnit = "day";
      return window
        .moment(date)
        .subtract(parseInt(number), lessUnit)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    },

    /**
     * Método que genera una cadena alfanumérica aleatoria de una longitud determinada
     */
    randomString(length) {
      let chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let result = "";
      for (let i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    /**
     * Método que devuelve las opciones de paginación (ítems por página)
     */
    paginationOptions() {
      return [10, 20, 50, 100];
    },
    /**
     * Método que devuelve el valor por defecto para el número de ítems por página
     */
    defaultPagination() {
      return 10;
    },
    /**
     * Método que devuelve las opciones de sistemas de origen de videos
     */
    fontOptions() {
      return [
        { value: null, text: i18n.t("configs.selectfont") },
        { value: "FF Unit", text: "FF Unit" },
        { value: "Lato Extended", text: "Lato Extended" },
        { value: "OpenSans", text: "OpenSans" },
        { value: "Proeduca", text: "Proeduca" },
      ];
    },
    isStaff(user) {
      if (user.unirType !== "P") {
        return false;
      } else {
        return true;
      }
    },
    notNullOrUndefined(value) {
      if (undefined !== value && value != null) {
        return true;
      } else {
        return false;
      }
    },
  },
};
